<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true"
     (onShown)="daysNotFilledFocus = true"
     (onHidden)="daysNotFilledFocus = false">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" style="margin-left:0px">
                    <div class="small-text">Not Filled in x Days</div>
                    <div #daysNotFocused class="input-no-arrows">
                        <input [autofocus] = "daysNotFilledFocus"
                               type="number" 
                               class="qty"
                               required
                               step=1
                               min="1"
                               placeholder=" "
                               [(ngModel)]="daysNotFilled">
                               <em class="error">Please enter a valid number of days.</em>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                </div>
                <div class="float-right text-align-right">
                    <button (click)="generateContent()" class="btn btn-primary" [disabled]="!canGenerateReport()">
                        <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">Download</button>
                </div>
            </div>
        </div>
    </div>
</div>